import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true, // Set this to "true" if you're having issues on IE11 or Edge
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

export const graphLoginRequest = {
  scopes: ["User.Read"]
};

export const dbLoginRequest = {
  scopes: ["https://database.windows.net/.default"]
};

export { msalInstance };
